import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-audio-uploaded',
  templateUrl: './audio-uploaded.component.html',
  styleUrls: ['./audio-uploaded.component.scss']
})
export class AudioUploadedComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  @Input() public type;

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
